import { useState } from 'react';
import {
  getAuth,
  signInWithEmailAndPassword,
  getMultiFactorResolver,
} from 'firebase/auth';

import { SIGN_IN_DESTINATIONS, decideSignInDestination } from '../policy/signInPolicy';
import { getSafeErrorIdentifier } from '../../utils/getSafeErrorIdentifier';

export default function useEmailSignIn({
  tenantID,
  getSessionCookie,
  setResolverAuth,
  setCurrentView,
  showMfaEnrollmentChooser,
  setLoginErrorKey,
  setIsLoading,
  setIsLoadingRedirect,
}) {
  const [email, setMail] = useState('');
  const [password, setPw] = useState('');

  const handleChangeEmail = event => {
    setMail(event.target.value);
  };
  const handleChangePassword = event => {
    setPw(event.target.value);
  };

  const SignInWithEmail = event => {
    event.preventDefault();
    // Validate before flipping the loading flag: nothing resets it on the
    // empty-fields path, so setting it first left the button stuck disabled.
    if (email === '' || password === '') {
      return;
    }
    // A misconfigured deploy (a missing tenant id env var) must never reach
    // signInWithEmailAndPassword with auth.tenantId left undefined — that
    // would sign into the project's whole user pool instead of a tenant.
    if (!tenantID) {
      setLoginErrorKey('heimdal_app.Login.try_again_later');
      return;
    }
    setIsLoadingRedirect(true);
    setLoginErrorKey(null);
    const auth = getAuth();
    auth.tenantId = tenantID;
    signInWithEmailAndPassword(auth, email, password)
      .then(userCredential => {
        const idToken = userCredential._tokenResponse.idToken;
        const refreshToken = userCredential._tokenResponse.refreshToken;
        const destination = decideSignInDestination(userCredential.user);
        if (destination === SIGN_IN_DESTINATIONS.MFA_ENROLLMENT_CHOOSER) {
          setIsLoading(true);
          showMfaEnrollmentChooser(userCredential.user);
        } else {
          const body = { idToken, refreshToken };
          getSessionCookie(body);
        }
      })
      .catch(error => {
        if (error.code === 'auth/too-many-requests') {
          setLoginErrorKey('heimdal_app.Login.too_many_requests');
        } else if (error.code === 'auth/user-disabled') {
          setLoginErrorKey('heimdal_app.Login.user_disabled');
        } else if (error.code === 'auth/multi-factor-auth-required') {
          const resolver = getMultiFactorResolver(auth, error);
          setResolverAuth(resolver);
        } else if (error.code === 'auth/user-token-expired') {
          setLoginErrorKey('heimdal_app.Login.try_again_later');
        } else {
          console.error(
            'useEmailSignIn.SignInWithEmail:',
            getSafeErrorIdentifier(error),
          );
          setLoginErrorKey('heimdal_app.Login.invalid_credentials');
        }
        setIsLoadingRedirect(false);
      });
  };

  return {
    email,
    password,
    handleChangeEmail,
    handleChangePassword,
    SignInWithEmail,
  };
}
